import { render, staticRenderFns } from "./wxFeedBack.vue?vue&type=template&id=371bf21e"
import script from "./wxFeedBack.vue?vue&type=script&lang=js"
export * from "./wxFeedBack.vue?vue&type=script&lang=js"
import style0 from "./wxFeedBack.vue?vue&type=style&index=0&id=371bf21e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports